import {Redirect, Route, Switch} from 'react-router-dom';
import Urls from '../../constants/urls';
import LRScene from './LRScene';
import {lockerRoom1Hotspot, lockerRoom2Hotspot, lockerRoom3Hotspot} from './data';

const LRRooms = () => {
  return (
    <Switch>
      <Route
        {...Urls.lockerRoom.root}
        render={() => <Redirect to={Urls.lockerRoom.lockerRoom1} />}
      />
      <Route {...Urls.lockerRoom.lockerRoom1}>
        <LRScene
          id="lr-locker-room1"
          yRotation={360}
          hotspots={lockerRoom1Hotspot}
        />
      </Route>
      <Route {...Urls.lockerRoom.lockerRoom2}>
        <LRScene
          id="lr-locker-room2"
          yRotation={360}
          hotspots={lockerRoom2Hotspot}
        />
      </Route>
      <Route {...Urls.lockerRoom.lockerRoom3}>
        <LRScene
          id="lr-locker-room3"
          yRotation={360}
          hotspots={lockerRoom3Hotspot}
        />
      </Route>
    </Switch>
  );
};

export default LRRooms;
